<template>
  <div class="block">
    <!-- Question -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>Question</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="shareholderFaq.question"
          placeholder="請輸入問題"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- Answer -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>Answer</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <editor
          v-model="shareholderFaq.ans"
          :plugins="'link'"
          :toolbar="'link'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    Editor,
  },
  computed: {
    ...mapState('shareholderFaq', ['shareholderFaq']),
  },
};
</script>

<style></style>
